import { isElectron } from "@/lib/platform";

type SharedLogicConfig<T> = {
	web: () => T;
	electron: () => T;
};

export function useSharedLogic<T>(config: SharedLogicConfig<T>): T {
	if (isElectron) {
		return config.electron();
	}
	return config.web();
}
